import { useEffect, useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { MapPinned, Search, Calculator, Info, Settings, Newspaper } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const items = [{ to: '/', key: 'map', icon: MapPinned, end: true }, { to: '/search', key: 'search', icon: Search }, { to: '/news', key: 'news', icon: Newspaper }, { to: '/calculate', key: 'calculator', icon: Calculator }, { to: '/insight', key: 'guide', icon: Info }];
// 모바일 하단 탭: 금리 검색은 지도 검색바·목록으로, 이용 안내는 설정 페이지 안으로
const tabs = [{ to: '/', key: 'map', icon: MapPinned, end: true }, { to: '/news', key: 'news', icon: Newspaper }, { to: '/calculate', key: 'calculator', icon: Calculator }, { to: '/settings', key: 'settings', icon: Settings }];
const read = (k, d) => { try { return localStorage.getItem(k) || d; } catch { return d; } };
const write = (k, v) => { try { localStorage.setItem(k, v); } catch { /* 저장 불가 환경 */ } };

// 테마: 시스템 설정을 따르거나 라이트/다크 고정 (설정 페이지에서 Outlet context로 변경)
function useTheme() {
  const [theme, setTheme] = useState(() => read('bankpark-theme', 'system'));
  useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const apply = () => { document.documentElement.dataset.theme = theme === 'system' ? (media.matches ? 'dark' : 'light') : theme; };
    apply(); write('bankpark-theme', theme);
    media.addEventListener('change', apply);
    return () => media.removeEventListener('change', apply);
  }, [theme]);
  return [theme, setTheme];
}

export default function AppShell() {
  const { t } = useTranslation();
  const [theme, setTheme] = useTheme();
  const nav = (list, cls) => list.map(({ to, key, icon: Icon, end }) => <NavLink key={to} to={to} end={end} className={({ isActive }) => `${cls} ${isActive ? 'active' : ''}`} title={t(`nav.${key}`)} aria-label={t(`nav.${key}`)}><Icon size={cls === 'tab' ? 26 : 24} strokeWidth={1.75}/><span>{t(`nav.${key}`)}</span></NavLink>);
  return <div className="shell">
    <aside className="sidebar">
      <NavLink to="/" className="brand" aria-label="뱅크피클 BankPickle"><img className="brand-logo" src="/brand/logo96.png" alt="" width="32" height="32"/><span className="brand-word"><b>Bank</b>Pickle</span></NavLink>
      <nav className="side-menu" aria-label="Main navigation">{nav(items, 'nav-item')}</nav>
      <div className="sidebar-bottom">{nav([{ to: '/settings', key: 'settings', icon: Settings }], 'nav-item')}</div>
    </aside>
    <div className="shell-content"><Outlet context={{ theme, setTheme }}/></div>
    <nav className="tabbar" aria-label="Mobile navigation">{nav(tabs, 'tab')}</nav>
  </div>;
}
